module.exports = __webpack_public_path__ + "static/media/gota.543975ed.png";